
import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-toast',
    imports: [],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {

    assetsCDNUrl = environment.assetsCDNUrl;
    @Input() toastMsg: any;
    @Input() showToastFailure: any;


    handler__close() {
        this.toastMsg = "";
        this.showToastFailure = false;
    }
}
